import _ from 'lodash';
import React from 'react';
import { Button, Tag, Text } from 'src/@vymo/ui/atoms';
import { Card } from 'src/@vymo/ui/blocks';
import { ReactComponent as RightArrow } from 'src/assets/icons/right.svg';
import { useAppDispatch } from 'src/store/hooks';
import Progress from '../../components/progress';
import { keyMetricDetailsNavigation } from '../../queries';
import {
  getMetricData,
  getMetricProgressColor,
  getMetricProgressPercent,
} from './queries';
import styles from './index.module.scss';

function KeyMetricCard({ metric }) {
  const dispatch = useAppDispatch();
  const { total, actual } = getMetricData(metric);
  const progressPercentage = getMetricProgressPercent(metric);
  const progressColor = getMetricProgressColor(metric);
  const isDrilldownDisabled =
    metric?.data?.body?.result?.group_by_key?.disable_drilldown;
  return (
    <Card classNames={styles.keyMetricsWrapper__card}>
      <div className={styles.keyMetricsWrapper__card__title}>
        <Text>{metric?.title}</Text>
        {!isDrilldownDisabled && (
          <Button
            onClick={() =>
              keyMetricDetailsNavigation({
                params: {
                  frequency: metric?.card?.frequency ?? '',
                  start_date: metric?.card?.date_range?.start ?? '',
                  title: metric?.card?.title,
                },
                code: metric?.code,
                dispatch,
              })
            }
            type="text"
            rounded
            isIcon
            iconProps={{
              icon: <RightArrow />,
              iconPosition: 'left',
            }}
          />
        )}
      </div>

      <Tag label={metric?.card?.frequency} type="secondary" />

      <div className={styles.keyMetricsWrapper__card__stats}>
        <div>
          <Text type="h5">{actual} </Text>
          {Boolean(total) && <Text>/ {total}</Text>}
        </div>

        {!_.isNil(progressPercentage) && (
          <div className={styles.keyMetricsWrapper__card__stats__percent}>
            <Progress color={progressColor} progress={progressPercentage} />
            <div
              style={{ color: progressColor }}
              className={styles.keyMetricsWrapper__card__stats__percent__text}
            >
              {progressPercentage}%
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}

export default KeyMetricCard;
